module.exports = __webpack_public_path__ + "1f51e2eb0db23c3329a9f3ed76bbc7a7.png";